export var ExplanationCode;
(function (ExplanationCode) {
    ExplanationCode["ACCOUNT_BLOCKED"] = "222";
    ExplanationCode["LOCK_BY_IP_ADDRESS"] = "1001";
    ExplanationCode["LOCK_BY_USERNAME"] = "1002";
    ExplanationCode["LOCK_BY_EMAIL_FOR_RESET_PASSWORD"] = "1003";
    ExplanationCode["CHANGE_PASSWORD_REQUIRED"] = "2001";
})(ExplanationCode || (ExplanationCode = {}));
//# sourceMappingURL=ExplanationCode.js.map